import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bgu7e2icoo: FaireBrandEntity = {
  token: "b_bgu7e2icoo",
  type: "brand",
  name: "Spiffy & Splendid",
  avatarUrl:
    "https://cdn.faire.com/fastly/bdebad3d487b2377b419a4c180513dea07a6eeda09c0e2a641b6f7d4cebd0a0f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/15fba9ba39737354b7e2c461ede9dbbddbb754552ff702a3fc5b22c00edc166f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/bdebad3d487b2377b419a4c180513dea07a6eeda09c0e2a641b6f7d4cebd0a0f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/15fba9ba39737354b7e2c461ede9dbbddbb754552ff702a3fc5b22c00edc166f.png",
  location: "Fishers, IN, USA",
  minimumOrderDollars: 95,
  rating: 5,
  reviewCount: 562,
  isTopShop: true,
  isInsider: true,
  description:
    "*Orders ship next business day!*\n\nSpiffy & Splendid is a woman-owned jewelry company located in Fishers, Indiana. We are family operated by a husband-and-wife team along with a team of local women who hand-craft our jewelry.\nOur mission is to create joy-filled jewelry that is unique, high-quality, and all at a great price point.\nWe specialize in fun and trendy styles to make every woman feel spiffy and splendid!\n   Spiffy: fashionable, stylish & trendy \n   Splendid: fabulous, wonderful & beautiful\nWe have spent countless time perfecting our products. That is why you'll find quality gold-plated stainless-steel materials for our posts, hooks, and necklace chains and durable acrylics for our unique designs. We continue to hear from our customers how much they love our products for their sensitive ears. Creativity is our passion, so we are always committed to bringing you fresh styles.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:33.078Z",
    importedBy: "entity-db-cli",
  },
};
